import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import React__default from 'react';
import LightAsync from 'react-syntax-highlighter/dist/esm/light-async';
import dark from 'react-syntax-highlighter/dist/esm/styles/hljs/dark';
import docco from 'react-syntax-highlighter/dist/esm/styles/hljs/docco';
import { CopyTextButton } from '../CopyTextButton/CopyTextButton.esm.js';

function CodeSnippet(props) {
  const {
    text,
    language,
    showLineNumbers = false,
    highlightedNumbers,
    customStyle,
    showCopyCodeButton = false
  } = props;
  const theme = useTheme();
  const mode = theme.palette.type === "dark" ? dark : docco;
  const highlightColor = theme.palette.type === "dark" ? "#256bf3" : "#e6ffed";
  return /* @__PURE__ */ React__default.createElement(Box, { position: "relative" }, /* @__PURE__ */ React__default.createElement(
    LightAsync,
    {
      customStyle,
      language,
      style: mode,
      showLineNumbers,
      wrapLines: true,
      lineNumberStyle: { color: theme.palette.textVerySubtle },
      lineProps: (lineNumber) => highlightedNumbers?.includes(lineNumber) ? {
        style: {
          backgroundColor: highlightColor
        }
      } : {}
    },
    text
  ), showCopyCodeButton && /* @__PURE__ */ React__default.createElement(Box, { position: "absolute", top: 0, right: 0 }, /* @__PURE__ */ React__default.createElement(CopyTextButton, { text })));
}

export { CodeSnippet };
//# sourceMappingURL=CodeSnippet.esm.js.map
